var _mask, _g, _mask2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0email",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4524 0.987061H1.88291C0.856068 0.990631 0.026369 1.76061 0.0287625 2.70776L0 14.7433L1.05539 14.7385L1.0846 2.8022L10.3786 8.44533C10.4647 8.49726 10.5653 8.52497 10.6682 8.52509C10.7695 8.52518 10.8687 8.49814 10.9537 8.44725L20.2502 2.90273L20.2505 13.025C20.2514 13.4324 19.8945 13.7636 19.4528 13.7652H3.19933V14.7433H19.4528C20.4784 14.7396 21.3073 13.971 21.3059 13.025L21.3056 2.70537C21.307 1.75937 20.4781 0.990759 19.4524 0.987061Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0email)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4358 -4.91321H-2.13086V18.6691H23.4358V-4.91321Z",
    fill: "#0E5AA7"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1email",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 19,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3891 1.99548H1.81959C1.75463 1.99986 1.69055 2.0119 1.62891 2.03131L9.62548 6.88729L10.6305 7.46927L19.7053 2.05741C19.6057 2.01682 19.498 1.99574 19.3891 1.99548Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1email)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.4358 -4.91321H-2.13086V18.6691H23.4358V-4.91321Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.7311a69d1f5d05b4caa98ee5299133a7dc11f5ba28897b4e0141056a26dc36ff.svg";
export { ForwardRef as ReactComponent };